import React from "react";
import "./Agency_header.css"
function Agency_header() {
  return (
    <>
      <section className="Agency_header">
        <div className="commission_header_bg">
          <div className="bg_holder">
            <img
              src="/assets/images/agency/bg.png"
              className="bg_img"
              alt="bg"
            />
          </div>
          <div class="commission-header">
            <h2 class="commission-amount">0.19</h2>
            <p class="commission-subtitle">Yesterday's total commission</p>
            <p class="commission-upgrade">
              Upgrade the level to increase commission income
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Agency_header;
